/** 运行公用mixin */

import RedcatEventBus from '@/plugins/redcatEventBus'

const rcTableEditViaForm = {
  provide () {
    return {
      id: this.id,
      _redcatEventBus: this.redcatEventBus
    }
  },
  inject: {
    _redcatEventBus: {
      default: null
    }
  },
  data () {
    return {
      rcTableFormRuntimeDialog: {
        title: '',
        type: 'form',
        visible: false,
        id: '',
        width: '',
        tableEdit: {
          componentId: '', // 当前正在编辑的表格的控件id，用以区分不同的表格实例
          switch: true,
          data: {}
        }
      },
      redcatEventBus: this._redcatEventBus || new RedcatEventBus()
    }
  },
  created () {
    // 使用表单id作为标识，针对不同表单创建多个监听实例, 如果不存在才创建
    let index = this.redcatEventBus.formRuntimeListenerArray.findIndex(item => item.id === this.id)
    if (index === -1) {
      let redcatEventBus = new RedcatEventBus()
      redcatEventBus.$on('tableEditCreate', this.createNewRcTableEventBus)
      redcatEventBus.$on('rcTable.editViaForm', this.editViaForm)
      this.redcatEventBus.formRuntimeListenerArray.push({
        id: this.id,
        redcatEventBus
      })
    }
  },
  beforeDestroy () {
    // 退出时将表单所属事件从实例数组中剔除，同时销毁掉所有相应事件
    let needDestroyFormEventBusIndex = this.redcatEventBus.formRuntimeListenerArray.findIndex(item => item.id === this.id)
    if (needDestroyFormEventBusIndex !== -1) {
      let needDestroyFormEventBus = this.redcatEventBus.formRuntimeListenerArray.splice(needDestroyFormEventBusIndex, 1)
      needDestroyFormEventBus[0].redcatEventBus.$off()
    }
  },
  methods: {
    // 创建新的表格eventBus实例
    createNewRcTableEventBus (id) {
      this.redcatEventBus.rcTableListenerArray.push({
        id,
        redcatEventBus: new RedcatEventBus()
      })
    },
    // 表格开启表单编辑
    editViaForm ({params, id}) {
      this.rcTableFormRuntimeDialog.id = params.id
      this.rcTableFormRuntimeDialog.width = params.width
      this.rcTableFormRuntimeDialog.tableEdit.data = params.data
      this.rcTableFormRuntimeDialog.title = params.title
      this.rcTableFormRuntimeDialog.visible = true
      this.rcTableFormRuntimeDialog.tableEdit.componentId = id
      this.rcTableFormRuntimeDialog.disabled = params.disabled
    }
  }

}

export { rcTableEditViaForm }



// WEBPACK FOOTER //
// ./src/components/shared/runtimeMixins/index.js